import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// tslint:disable-next-line
import { NgWizardConfig, NgWizardService, StepChangedArgs, STEP_STATE, THEME } from 'dapda-ng-wizard';
import { Observable } from 'rxjs';
import { NewAssignmentRulesInput } from '../../../shared/models/common/assigmentRules/newAssignmentRulesInput';
import { ModalsHandlerService } from '../modals.handler.service';
import { AssignmentRuleInput } from './../../../shared/models/common/assigmentRules/assignmentRuleInput';
import { AssignmentRulesEvent } from './../../../shared/models/common/assigmentRules/assignmentRulesEvent';
import { AssignmentRulesService } from './../../../shared/services/assignmentRules/assignment-rules.service';
import { CreateAssignmentRulesService } from './../../../shared/services/assignmentRules/create-assignment-rules.service';
import { EventService } from './../../../shared/services/event/event.service';
import { ToastService } from './../../../shared/services/utils/toast.service';
import { TranslatorService } from './../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-create-assignment-rules-modal',
  templateUrl: './create-assignment-rules-modal.component.html',
  styleUrls: ['./create-assignment-rules-modal.component.scss']
})
export class CreateAssignmentRulesModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: ElementRef;

  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.dots,
  };

  title: string;
  assignmentRuleForm: any;
  assignmentRule = new AssignmentRuleInput();
  brandSelected: any;
  channelSelected: any;
  dealerSelected: any;
  typeSelected: any;
  modalEmitter: EventEmitter<any>;
  originAutocomplete: any;
  originSelected: any;

  activeRulesSelected: any;
  onDeSelectActiveRules: string;

  positiveRulesSelected: any;
  onDeSelectPositiveRules: string;

  titleStepOne: string;
  titleStepOneDescription: string;
  titleStepTwo: string;
  titleStepTwoDescription: string;
  titleStepThree: string;
  titleStepThreeDescription: string;
  titleStepFour: string;
  titleStepFourDescription: string;
  titleStepFive: string;
  titleStepFiveDescription: string;
  titleStepSix: string;
  titleStepSixDescription: string;
  titleStepSeven: string;
  titleStepSevenDescription: string;
  titleStepEight: string;
  titleStepEightDescription: string;
  titleStepNine: string;
  titleStepNineDescription: string;
  titleStepTen: string;
  titleStepTenDescription: string;

  originSelectedList = [];
  originExists = false;
  originIsEmpty = false;

  postalCodeSelectedList = [];
  postalCodeExists = false;
  postalCodeIsEmpty = false;
  isPostalCodeRange = true;

  actualStepIndex = 0;

  newAssignmentRules: NewAssignmentRulesInput = new NewAssignmentRulesInput();
  sending = false;
  allSelectedString = this.translatorService.trans(`drag-and-drop.all-selected`);
  canExit: boolean;
  missingRuleUsers: boolean;
  missingRuleName: boolean;
  previousStepDisabled = true;
  nextStepDisabled = false;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly ngWizardService: NgWizardService,
    private readonly translatorService: TranslatorService,
    protected formBuilder: FormBuilder,
    private readonly eventService: EventService,
    private readonly createAssignmentRuleService: CreateAssignmentRulesService,
    protected toasterService: ToastService,
    private readonly assignmentRulesService: AssignmentRulesService,
  ) { }

  ngOnInit() {
    this.createTitles();

    this.modalsHandler.createAssingmentRuleModal.subscribe(() => {
      this.open();

      this.assignmentRuleForm = this.formBuilder.group({
        assignmentRuleName: ['', [Validators.required]],
        assignmentRuleUsers: [[], [Validators.required]],
        postalCode: ''
      });
    });

    this.eventService.subscribe(AssignmentRulesEvent.ASSIGNMENT_RULE_USER_SELECTED, data => {
      data > 0 ? (this.canExit = true, this.missingRuleUsers = false) : (this.canExit = false, this.missingRuleUsers = true);
    });
  }

  ngAfterViewInit(): void {
  }

  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.detectIfMissingUsers();

    if (!this.isValidForm()) {
      return;
    }
    this.ngWizardService.next();

  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.actualStepIndex = args.step.index;
    if (this.actualStepIndex === 0) {
      this.previousStepDisabled = false;
    } else {
      this.previousStepDisabled = true;
    }

    if (this.actualStepIndex === 7) {
      this.nextStepDisabled = false;
    } else {
      this.nextStepDisabled = true;
    }
    this.createHelpText(this.actualStepIndex);
  }

  processForm(
    ruleName: any,
    dragAndDropUserItems: any,
    positiveRule: any,
    isActive: any,
    dragAndDropTypeItems?: any,
    dragAndDropBrandItems?: any,
    dragAndDropChannelItems?: any,
    dragAndDropDealerItems?: any,
  ): void {

    this.checkIfAllSelected(dragAndDropTypeItems);

    this.newAssignmentRules.assignmentRules = this.createAssignmentRuleService.generateRule(
      ruleName,
      dragAndDropUserItems.selectedItems,
      positiveRule,
      isActive,
      this.cleanEmptyDragAndDrop(this.checkIfAllSelected(dragAndDropTypeItems)),
      this.cleanEmptyDragAndDrop(this.checkIfAllSelected(dragAndDropDealerItems)),
      this.cleanEmptyDragAndDrop(this.checkIfAllSelected(dragAndDropChannelItems)),
      this.cleanEmptyDragAndDrop(this.checkIfAllSelected(dragAndDropBrandItems)),
      this.originSelectedList,
      this.postalCodeSelectedList.map(element => {
        const elements = element.split(' - ');
        return elements.length === 2 ? this.getStartPostalCode(elements[0], elements[1]) : element;
      })
    );

    if (this.newAssignmentRules.assignmentRules.length > 0) {
      this.launchQuery();
    }
    this.closeModal();
  }

  launchQuery(): void {
    const toasterSuccess = { title: 'toaster.new.rules.title', body: 'toaster.new.rules.success.body' };
    const toasterError = { title: 'toaster.new.rules.title', body: 'toaster.new.rule.unhandled_error' };
    const toasterRepeatedError = { title: 'toaster.new.repeated_rule.error.title', body: 'toaster.new.repeated_rule.error.body' };
    this.subscribeMe(
      this.assignmentRulesService.newAssignmentRules$(this.newAssignmentRules),
      toasterSuccess,
      toasterRepeatedError,
      toasterError
    );
  }

  subscribeMe(observable: Observable<any>, toasterSuccess: any, toasterRepeatedError: any, toasterError: any): void {
    observable.subscribe((data) => {
      this.sending = true;

      if (data.data.newAssignmentRules.successes > 0) {
        this.toasterService
          .showToast(
            'success',
            toasterSuccess.title,
            this.translatorService.trans(toasterSuccess.body)
              .replace('REPLACE_THIS', `${data.data.newAssignmentRules.successes}`)
          );

        this.eventService.broadcast(AssignmentRulesEvent.ASSIGNMENT_RULE_CREATED);
      }

      if (data.data.newAssignmentRules.repeatedRules > 0) {
        this.toasterService
          .showToast(
            'error',
            toasterRepeatedError.title,
            this.translatorService.trans(toasterRepeatedError.body)
              .replace('REPLACE_THIS', `${data.data.newAssignmentRules.repeatedRules}`)
          );
      }

      this.sending = false;
    }, () => {
      this.toasterService
        .showToast(
          'error',
          toasterError.title,
          toasterError.body
        );
      this.sending = false;
    });
  }

  isValidForm(): boolean {
    if (!this.assignmentRuleForm.get('assignmentRuleName').hasError('required')) {
      this.missingRuleName = false;
      return true;
    }

    this.missingRuleName = true;
    return false;
  }

  closeModal() {
    this.resetWizard();
    this.clearModal();
    this.modalService.dismissAll();
  }

  bindForm(): void {
    Object.assign(this.assignmentRule, this.assignmentRuleForm.value);
  }

  goToStep(step) {
    this.detectIfMissingUsers();

    if (this.isValidForm()) {
      this.ngWizardService.show(step);
    }
  }

  addPostalCode(postalCode: string) {
    if (!postalCode) {
      this.postalCodeIsEmpty = true;
    } else {
      this.postalCodeIsEmpty = false;

      if (this.postalCodeSelectedList.includes(postalCode)) {
        this.postalCodeExists = true;
      } else {
        this.postalCodeExists = false;
        this.postalCodeSelectedList.push(postalCode);
      }
    }
  }

  private getStartPostalCode(from, to) {
    let result = '';
    for (let i = 0; i < from.length; i++) {
      if (from.substring(0, i) === to.substring(0, i)) {
        result = from.substring(0, i);
      }
    }
    return result;
  }

  completePostalCodeRange(postalCode) {
    if ( this.isPostalCodeRange && postalCode.target.value.length === 5) {
      postalCode.target.value += ' - ' + postalCode.target.value.substring(0, postalCode.target.value.indexOf('0')).padEnd(5, '9');
    }
  }

  validatePostalCode(postalCode) {
    if (!postalCode.target.value.includes(' - ')) {
      postalCode.target.value = postalCode.target.value.replace(/[^0-9]/g, '');
    } else {
      const codes = postalCode.target.value.split(' - ').map(code => code.replace(/[^0-9]/g, ''));
      postalCode.target.value = `${codes[0]} - ${codes[1]}`;
    }

  }

  addOrigin(origins: string[]) {
    if (!origins || origins.length < 1) {
      this.originIsEmpty = true;
    } else {
      this.originIsEmpty = false;

      if (this.originSelectedList.some(origin => origins.indexOf(origin) >= 0)) {
        this.originExists = true;
      } else {
        this.originExists = false;
        this.originSelectedList = origins;
      }
    }
  }

  removeOrigin(origin: string) {
    const originIndex = this.originSelectedList.indexOf(origin);
    if (originIndex !== -1) {
      this.originSelectedList.splice(originIndex, 1);
    }
  }

  removePostalCode(postalCode: string) {
    const postalCodeIndex = this.postalCodeSelectedList.indexOf(postalCode);
    if (postalCodeIndex !== -1) {
      this.postalCodeSelectedList.splice(postalCodeIndex, 1);
    }
  }

  private open() {
    this.modalService
      .open(this.content, {
        size: 'lg',
        container: 'nb-layout',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static', keyboard: false,
        windowClass: 'modal-xl-assignment'
      }).result.finally(() => {
        this.newAssignmentRules.assignmentRules = [];
      });
  }

  private cleanEmptyDragAndDrop(itemsSelected: any) {
    const index = itemsSelected.map((item) => item.name).indexOf(this.allSelectedString);
    return (index > -1) ? [] : itemsSelected;
  }

  private checkIfAllSelected(itemToProcess) {
    return (itemToProcess.itemsList.length < 1) ? [] : itemToProcess.itemsSelected;
  }

  private clearModal() {
    this.originSelectedList = [];
    this.originIsEmpty = false;
    this.originExists = false;
    this.postalCodeSelectedList = [];
    this.postalCodeIsEmpty = false;
    this.postalCodeExists = false;
  }

  private createTitles() {
    this.title = this.translatorService.trans('pages.create.assignment-rule.title');
    this.titleStepOne = this.translatorService.trans('pages.create.assignment-rule.step_1');
    this.titleStepOneDescription = this.translatorService.trans('pages.create.assignment-rule.step_1.description');

    this.titleStepTwo = this.translatorService.trans('pages.create.assignment-rule.step_2');
    this.titleStepTwoDescription = this.translatorService.trans('pages.create.assignment-rule.step_2.description');

    this.titleStepThree = this.translatorService.trans('pages.create.assignment-rule.step_3');
    this.titleStepThreeDescription = this.translatorService.trans('pages.create.assignment-rule.step_3.description');

    this.titleStepFour = this.translatorService.trans('pages.create.assignment-rule.step_4');
    this.titleStepFourDescription = this.translatorService.trans('pages.create.assignment-rule.step_4.description');

    this.titleStepFive = this.translatorService.trans('pages.create.assignment-rule.step_5');
    this.titleStepFiveDescription = this.translatorService.trans('pages.create.assignment-rule.step_5.description');

    this.titleStepSix = this.translatorService.trans('pages.create.assignment-rule.step_6');
    this.titleStepSixDescription = this.translatorService.trans('pages.create.assignment-rule.step_6.description');

    this.titleStepSeven = this.translatorService.trans('pages.create.assignment-rule.step_7');
    this.titleStepSevenDescription = this.translatorService.trans('pages.create.assignment-rule.step_7.description');

    this.titleStepEight = this.translatorService.trans('pages.create.assignment-rule.step_8');
    this.titleStepEightDescription = this.translatorService.trans('pages.create.assignment-rule.step_8.description');

    this.titleStepNine = this.translatorService.trans('pages.create.assignment-rule.step_9');
    this.titleStepNineDescription = this.translatorService.trans('pages.create.assignment-rule.step_9.description');

    this.titleStepTen = this.translatorService.trans('pages.create.assignment-rule.step_10');
    this.titleStepTenDescription = this.translatorService.trans('pages.create.assignment-rule.step_10.description');
  }

  private createHelpText(stepPosition) {
    document.getElementById(`help-text-step-${stepPosition + 1}`).innerHTML = this.translatorService.trans(`help.assignment-rules.step-${stepPosition + 1}`);
  }

  private detectIfMissingUsers() {
    if (this.canExit === undefined || !this.canExit) {
      this.missingRuleUsers = true;
    } else {
      this.missingRuleUsers = false;
    }
  }
}
